import axios from "axios";
import { toast } from "sonner";

export const createCheckoutSession = (formData) => async (dispatch) => {
    await axios
        .post(`/api/payment/create-checkout-session`, { toolData: formData })
        .then((response) => {
            dispatch({ type: "CREATE_CHECKOUT_SESSION_SUCCESS" });
            if (response.data.redirect) {
                window.open(response.data.redirect, "_blank").focus();
            }
        })
        .catch((error) => {
            toast.error(error?.response?.data?.error, {
                duration: 3000,
            });
        });
};
